var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TreeIndex"},[_c('new-tree',{attrs:{"menuList":_vm.menuList,"onCheckedItem":_vm.onCheckedItem,"openGroup":_vm.openGroup,"level":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }